import type { TooltipProps } from '@shopify/polaris';

import { Tooltip } from '@shopify/polaris';

export interface GTooltipProps extends Omit<TooltipProps, 'content'> {
  /**
   * @default true
   */
  isEnabled?: boolean;
  content?: React.ReactNode | string;
  /**
   * - large: 285px
   * - extra-large: 340px
   * - double-extra-large: 360px
   * @param maxWidth 'large' | 'extra-large' | 'double-extra-large'
   * @default undefined
   */
  maxWidth?: 'large' | 'extra-large' | 'double-extra-large';
  activatorWrapper?: 'tooltip-content' | 'g-tooltip-card' | string;
  /**
   * @default 500ms
   */
  hoverDelay?: number;
}

export const GTooltip = ({ isEnabled = true, content, maxWidth, ...props }: GTooltipProps) => {
  const hasContent = isEnabled && !!content;

  return hasContent ? (
    <Tooltip
      width="wide"
      hoverDelay={500}
      content={content}
      {...props}
      accessibilityLabel={maxWidth?.toString()}
    />
  ) : (
    props.children
  );
};
